module.exports = __webpack_public_path__ + "static/08-ffbaf6e0b9550ee4939857c0d25d13e1.jpg";